import styled from "styled-components/native";
import { space, color } from "@sloth-system/styled-utils";

import { SpacerProps } from "./Spacer-component";

export { SpacerContainer };

function applyLine(props: any) {
  if (props.line) {
    let colorValue = typeof props.line === "string" ? props.line : "neutrals.0";
    return `&:after{
      position: absolute;
      left: 50%;
      top: 0; 
      width: 2px;
      height: 100%;
      transform: translateX(-50%);
      background: ${color(colorValue)(props)};
      content: "";
    }`;
  }
  return "";
}

let SpacerContainer = styled.View<SpacerProps>`
  position: relative;
  width: ${(props) => space(props.size)(props)};
  height: ${(props) => space(props.size)(props)};
  ${applyLine}
`;
